import { defineMessages, type useIntl } from 'react-intl'

/**
 * Leaf constants/helpers for My Trips sort and filter options.
 * Kept out of MyTripsListGrid so SortAndFilter can read them without the
 * SortAndFilter ↔ MyTripsListGrid cycle.
 */

export const MY_TRIPS_SORT_OPTIONS = [
  'last edited',
  'date created',
  'upcoming',
  'alphabetical',
] as const
export type MyTripsSortOptions = (typeof MY_TRIPS_SORT_OPTIONS)[number]

export const MY_TRIPS_FILTER_OPTIONS = [
  'owned by me',
  'shared with me',
] as const
export type MyTripsFilterOptions = (typeof MY_TRIPS_FILTER_OPTIONS)[number]

const sortOptionMessages = defineMessages<MyTripsSortOptions>({
  'last edited': {
    id: 'Npt2RXgheoa4dLcPfNR5',
    defaultMessage: 'Last edited',
    description: 'Sort option label: sort trips by last edited date in the trip planner',
  },
  'date created': {
    id: 'C3dAm6IKzyZre577Qbwq',
    defaultMessage: 'Date created',
    description: 'Sort option label: sort trips by creation date in the trip planner',
  },
  'upcoming': {
    id: 'qdJA6XD2IvR9TowR0ISU',
    defaultMessage: 'Upcoming',
    description: 'Sort option label: sort trips by upcoming start date',
  },
  'alphabetical': {
    id: 'yRuEpo90nwBzyvMF3bQ6',
    defaultMessage: 'Alphabetical',
    description: 'Sort option label: sort trips alphabetically by name',
  },
})

const filterOptionMessages = defineMessages<MyTripsFilterOptions>({
  'owned by me': {
    id: 'OFq2qD9Pod8GBb1y-xSp',
    defaultMessage: 'Owned by me',
    description: 'Filter option label: show only trips owned by current user',
  },
  'shared with me': {
    id: 'eJrIhvfvF-tHYB8LdCpJ',
    defaultMessage: 'Shared with me',
    description: 'Filter option label: show only trips shared with current user',
  },
})

export function getMyTripsSortOptionLabel(
  intl: ReturnType<typeof useIntl>,
  option: MyTripsSortOptions,
): string {
  return intl.formatMessage(sortOptionMessages[option])
}

export function getMyTripsFilterOptionLabel(
  intl: ReturnType<typeof useIntl>,
  option: MyTripsFilterOptions,
): string {
  return intl.formatMessage(filterOptionMessages[option])
}
